module.exports = __webpack_public_path__ + "arrow-right.a28d6941ba5b59457b51f3b23c4b2690.svg";